import styled from 'styled-components';
import { ListerSaveIcon } from '../../../../../components/Icons/ListerSaveIcon';
import { ListVehicleChat } from '../../../../../components/ListVehicles/components/Chat';
import { Popover } from '@material-ui/core';
import { useRef, useState } from 'react';
import { useGetChatMessagesQuery } from '../../../../../services/api/list-vehicles';
import { useOnClickOutside } from 'usehooks-ts';

const Wrapper = styled.div`
  cursor: pointer;
`;

type Props = {
  requestId: number;
};

export const ListerNotesBlock = ({ requestId }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: messages } = useGetChatMessagesQuery(requestId, {
    skip: !isOpen
  });

  const ref = useRef<any>(null);

  const showNotes = (e: any) => {
    window.scrollTo(0, document.body.scrollHeight);
    setIsOpen(true);
  };

  const hideNotes = () => {
    setIsOpen(false);
  };

  return (
    <Wrapper ref={ref}>
      <div onClick={showNotes}>
        <ListerSaveIcon isActive={isOpen} />
      </div>
      <Popover
        id="lister-chat-popover"
        anchorEl={ref.current}
        open={ref.current && isOpen}
        onClose={hideNotes}
        onBackdropClick={hideNotes}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        disableRestoreFocus
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <ListVehicleChat listRequestId={requestId} messages={messages || []} />
      </Popover>
    </Wrapper>
  );
};
